export const ExaminationType: any = [
    {
        value: 'nhi',
        label: 'Khám nhi',
    },
    {
        value: 'dinh_duong',
        label: 'Khám dinh dưỡng',
    },
];

export const ExaminationForm: any = [
    {
        value: 'online',
        label: 'Khám online',
    },
    {
        value: 'offline',
        label: 'Khám tại phòng khám',
    },
];

export const ConclusionType: any = [
    {
        value: 'conclusion',
        label: 'Kết luận',
    },
    {
        value: 'preliminary',
        label: 'Chẩn đoán',
    },
    {
        value: 'menu',
        label: 'Thực đơn',
    },
];

export const ReceiptsType: any = [
    {
        value: 'receipts',
        label: 'Thu tiền',
    },
    {
        value: 'payment',
        label: 'Chi tiền',
    },
];

export const ServiceType:any = [
    {
        value: '',
        label: '-Đối tác thực hiện-',
    },
    {
        value: 'labhouse',
        label: 'Labhouse',
    },
    {
        value: 'medlatec',
        label: 'Medlatec',
    },
];

export const OptionTime: any = [
    {
        value: '',
        label: 'Chọn'
    },
    {
        value: 'day',
        label: 'Ngày'
    },
    {
        value: 'month',
        label: 'Tháng'
    },
    {
        value: 'year',
        label: 'Năm'
    },
]
export const Product_status_warehouse : any = [
    {
        value: 'almost_out_of_stock',
        label: 'Sắp hết hàng'
    },
    {
        value: 'out_of_stock',
        label: 'Hết hàng'
    },
    {
        value: 'stocking',
        label: 'Còn hàng'
    },
]

export const Type_option_Exam : any = [
    {
        value: 'new_examination',
        label: 'Khám mới'
    },
    {
        value: 're_examination',
        label: 'Tái khám'
    },
]
